export default __webpack_public_path__ + "static/media/shareButton.2a517cb1.png";